import { Component, Input, OnInit, Optional, ViewChild, forwardRef, inject } from '@angular/core';
import { ControlContainer, FormsModule, NG_VALUE_ACCESSOR, NgForm } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SecurityService, setEntities, setTableFields } from '@wms/settings/security';
import { BaseComponent, WmsTypeaheadComponent, WmsToggleComponent, WMSEditorComponent, IWMSStandaloneEditorConstructionOptions, WmsMessageComponent } from '@wms/app/components';
import {find, forEach, get, includes, isEqual} from 'lodash-es';
import { isEmptyObject, replace } from '@wms/app/core';
import { QueryBuilderService, WmHttpService } from '@wms/app/services';
import { Subscription } from 'rxjs';

@Component({
  standalone: true,
  selector: 'wms-database',
  templateUrl: './database.component.html',
  styleUrls: ['./database.component.less'],
  imports: [CommonModule, FormsModule, WmsTypeaheadComponent, WmsToggleComponent, WMSEditorComponent, WmsMessageComponent],
  viewProviders: [{
    provide: ControlContainer,
    deps: [[Optional, NgForm]],
    useFactory: (ngForm: NgForm) => ngForm,
    multi: true
  }]
})
export class DatabaseComponent extends BaseComponent implements OnInit {
  @Input() securityProps: any;
  @Input() authInfo: any;
  @ViewChild("codeEditor") wmsEditorEl: WMSEditorComponent;
  securityService: SecurityService;
  security: any;
  scopeObj: any;
  queryPlaceholder: any;
  projectId: any;
  isValidQuery: boolean = true;
  errorMessage: any;
  editorOptions: IWMSStandaloneEditorConstructionOptions = {
    value: "",
    language: "sql",
    automaticLayout: true,
    renderLineHighlight: "none",
    wordWrap: "on",
    wrappingIndent: "indent",
    codeLens: false
  };
  queryEditorContent: any;
  formChangesSubscription: Subscription;
  resetFormSubscription: Subscription;
  initialRoleQueryData:boolean = true;
  isInitialLoad:boolean = false
  @ViewChild('databaseForm', { static: true }) ngForm: NgForm;
  private setInitialValue: boolean = true;
  selectedProvider:any
  ngOnInit(): void {
    if(this.securityService.security.provider.value === 'Database'){
      this.securityService.getDatabaseOptions(this.authInfo);
    }
    this.security = this.securityService.security;
    this.projectId = this.projectService.getProjectId();
    this.scopeObj = {
      security: this.security,
      securityProps: this.securityProps
    };
    this.selectedProvider = this.securityService.security.provider.value
    if (!isEmptyObject(this.securityService.databaseFormInititalValue[this.selectedProvider])) {
      this.setInitialValue = false;
      setTimeout(() => {
        this.ngForm.form.patchValue(this.securityService.databaseFormInititalValue[this.selectedProvider]);
      });
    }
    // this.handleWatchers(provider);
    this.formChangesSubscription = this.ngForm.form.valueChanges.subscribe(val => {
      if (!this.ngForm.form.dirty && this.setInitialValue && !this.ngForm.form.touched) {
        this.securityService.databaseFormInititalValue[this.selectedProvider] = this.ngForm.form.value;
      }
      if (this.ngForm.form.dirty) {
        if (this.isObjectEqual()) {
          this.security.dirtyCheckList.splice(this.security.dirtyCheckList.indexOf('databaseProvider', 1));
        } else if (!includes(this.security.dirtyCheckList, 'databaseProvider')) {
          this.security.dirtyCheckList.push('databaseProvider');
        }
      }
    });


    this.resetFormSubscription = this.securityService.resetForm.subscribe((resetInitialVal) => {
      if (!resetInitialVal) {
        this.security.tableName = this.securityService.databaseFormInititalValue[this.selectedProvider]['wm-security-db-entity']
        this.security.uidPropertyName = this.securityService.databaseFormInititalValue[this.selectedProvider]['wm-security-db-userid']
        this.security.unamePropertyName = this.securityService.databaseFormInititalValue[this.selectedProvider]['wm-security-db-username']
        this.security.pwPropertyName = this.securityService.databaseFormInititalValue[this.selectedProvider]['wm-security-db-password']
        this.security.rolePropertyName = this.securityService.databaseFormInititalValue[this.selectedProvider]['wm-security-db-role']
        this.ngForm.form.reset(this.securityService.databaseFormInititalValue[this.selectedProvider]);
        this.populateRolesQueryEditor()
      } else {
        this.securityService.databaseFormInititalValue[this.selectedProvider] = this.ngForm.form.value;
        this.security.roleQuery = this.securityService.editorContent
      }
    });

    this.securityService.populateQuery.subscribe(() => this.populateRolesQuery());

    // returning if this this function is invoked from providers other than database.
    if (this.security.provider.id !== 'DATABASE') {
      return;
    }
  }

  isObjectEqual() {
    let isEqual: boolean = true;
    forEach(this.securityService.databaseFormInititalValue[this.selectedProvider], (val: any, k: string) => {
      if (this.ngForm.form.value[k] != val) {
        isEqual = false;
        return false;
      }
      return true;
    });
    return isEqual;
  }

  updateRoleProp($event: any) {
    console.log($event);
    console.log($event.value);
    this.security.rolePropertyName = $event.value;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.securityService.databaseFormInititalValue[this.selectedProvider] = this.ngForm.form.value;
      this.securityService.populateDynamicQuery.subscribe(() => {
        this.populateRolesQueryEditor()
      });
    }, 1000);
  }

  populateRolesQueryEditor(){
    let authProvider: any = null;
    if(this.security.roleConfig === 'CUSTOM') {
      if (this.security.provider.id === 'OPENID') {
        authProvider = find(this.authInfo.authProviders, {
          type: this.security.provider.id,
          providerId: this.securityService.openId._selectModel
        });
      } else {
        authProvider = find(this.authInfo.authProviders, {type: this.security.provider.id});
      }
    }
    if(this.security.roleConfig === 'CUSTOM' && authProvider && (this.security.roleQuery || authProvider.roleMappingConfig?.roleQuery)){
    this.securityService.editorContent = this.security.roleQuery || authProvider.roleMappingConfig.roleQuery;
    this.wmsEditorEl.setEditorValue(this.security.roleQuery || authProvider.roleMappingConfig.roleQuery);
    this.security.isRolesQueryTested = true
    }
  }

  onExprChange() {
    this.securityService.editorContent = this.editorOptions.value = this.wmsEditorEl.options.value;
    if (this.securityService.editorContent === this.security.roleQuery) {
      if(this.isInitialLoad)
      this.security.dirtyCheckList.splice(this.security.dirtyCheckList.indexOf('databaseEditorProvider', 1));
    } else if (!includes(this.security.dirtyCheckList, 'databaseEditorProvider')) {
      this.security.dirtyCheckList.push('databaseEditorProvider');
      this.isInitialLoad = true
    }
    if(this.securityService.editorContent !== this.security.roleQuery){
        this.security.isRolesQueryTested = false
    }
   }

  setTableEntities() {
    let dataModel = this.security.modelName;
    //check for data-model
    if (!dataModel || dataModel === '') {
      return;
    }
    //Clear table name and other fields on change of database
    this.security.tableName = '';
    this.onTableNameClear();
    //check if data already exists
    if (this.securityProps.dbSchemas[dataModel]) {
      this.security.entities = this.securityProps.dbSchemas[dataModel];
    } else {
      setEntities(this.projectId, dataModel, this.scopeObj);
    }
  }

  setFields($event: any) {
    this.security.tableName = $event.value;
    let dataModel = this.security.modelName,
      entity = this.security.tableName,
      reset;

    //check for data-model
    if (!dataModel || dataModel === '') {
      reset = true;
    }
    if (reset) {
      this.security.tableName = '';
    }
    reset = false;

    //check for entity
    if (!entity || entity === '') {
      reset = true;
    }
    if (reset) {
      this.security.uidPropertyName = '';
      this.security.unamePropertyName = '';
      this.security.pwPropertyName = '';
      this.security.rolePropertyName = '';
      return;
    }

    if (this.securityProps.dbSchemas[dataModel][entity]) {
      this.security.tableFields = this.securityProps.dbSchemas[dataModel][entity];
    } else {
      setTableFields(this, dataModel, entity, this.scopeObj);
    }
  }

  //method to monitor change of switch widget
  onRoleConfigChange($event: any) {
    this.security.roleConfig = $event === true || $event === "BASIC" ? 'BASIC' : 'CUSTOM';
    if (!$event) {
      if(this.security.provider.id === "DATABASE"){
        this.wmsEditorEl.setEditorValue(this.securityService.editorContent);
        this.securityService.editorContent = this.queryEditorContent || this.securityService.editorContent;
      }
    } else {
      this.security.queryType = this.security.queryType || this.securityService.QUERY_TYPES.HQL;
    }
    this.security.useRolesQuery = this.security.roleConfig === 'CUSTOM';
    //Validate the role column selection on switch to Basic
    if (!this.security.useRolesQuery) {
      this.validateRoleColumn();
    }

    if(this.initialRoleQueryData){
      this.populateRolesQueryEditor()
      this.initialRoleQueryData = false
    }
  }

  onToggle($event: any) {
    this.security.queryType = $event === true ? 'NATIVE_SQL' : 'HQL';
    this.securityService.hideMessage(true)
    this.securityService.editorContent = '';
    this.wmsEditorEl.setEditorValue(this.securityService.editorContent);
  }

  validateRoleColumn() {
    let relationObject = find(this.securityProps.relations, { 'fieldName': this.securityProps.columnFieldMap[this.security.rolePropertyName] });
    if (relationObject) {
      this.errorMessage = this.getLocalizedMessage(['LABEL_INVALID_QUERY', this.security.rolePropertyName, relationObject.targetTable]);
      this.isValidQuery = false;
    } else {
      this.securityService.hideMessage(true);
      this.isValidQuery = true;
    }
    this.populateRolesQuery();
  }

  getLocalizedMessage(args: any) {
    let key = this.locale[args.shift()];
    return replace(key, args);
  }

  onTableNameClear() {
    this.security.uidPropertyName = '';
    this.security.unamePropertyName = '';
    this.security.pwPropertyName = '';
    this.security.rolePropertyName = '';
    this.security.tableName = '';
    this.security.tableFields = [];
    this.ngForm.form.markAsDirty()
  }

  //onclick of Test Query button
  testQuery() {
    this.securityService.hideMessage(true);
    if (!this.security.modelName) {
      this.securityService.hideMessage(false);
      this.securityService.showMessage(this.locale.MESSAGE_DATAMODEL_NOT_SET,'error')
      return;
    }
    if (!this.securityService.editorContent) {
      this.securityService.hideMessage(false);
      this.securityService.showMessage(this.locale.MESSAGE_QUERY_NOT_SET,'error')
      return;
    }

    if (!this.security.userName) {
      this.securityService.hideMessage(false);
      this.securityService.showMessage(this.locale.MESSAGE_QUERY_PARAMETER_NOT_SET,'error')
      return;
    }

    this.securityService.hideMessage(false);
    this.securityService.showMessage(this.locale.MESSAGE_TESTING_QUERY,'loading')

    this.queryBuilderService.executeQuery({
      'databaseName': this.security.modelName,
      'query': this.securityService.editorContent,
      'page': 1,
      'size': 10,
      'nativeSql': this.security.queryType !== this.securityService.QUERY_TYPES.HQL,
      'queryParams': [
        {
          'type': 'string',
          'name': 'LOGGED_IN_USERNAME',
          'testValue': this.security.userName
        }
      ]
    }, (response: any) => {
      this.securityService.hideMessage(false);
      let roles = response.content;
      this.security.sqlQueryRoles = Array.isArray(roles) ? roles : [];
      this.security.isRolesQueryTested = true;
      this.securityService.showMessage(this.locale.MESSAGE_QUERY_TESTED_SUCCESSFULLY,'success')
    }, (error: any) => {
      let errorObj = get(error, 'errors.error[0]');
      if (errorObj) {
        this.securityService.hideMessage(false);
        this.securityService.showMessage(this.httpService.parseError(errorObj),'error')
      } else {
        this.securityService.hideMessage(true);
      }
    });
  }

  createRolesBySqlQuery(table: any, userName: any, role: any, queryType: any) {
    if (queryType !== this.securityService.QUERY_TYPES.HQL) {
      role = role || "'DEFAULT_NO_ROLES'";
      table = table || 'USER';
      userName = userName || 'USERNAME';
    } else {
      role = this.securityProps.columnFieldMap[role] || 'role';
      table = this.securityProps.tableEntityMap[table] || 'User';
      userName = this.securityProps.columnFieldMap[userName] || 'username';
    }

    return 'SELECT ' + role + ' FROM ' + table + ' WHERE ' + userName + ' = :LOGGED_IN_USERNAME';
  }

  //function to populate roles query by default
  populateRolesQuery(saveEditorContent?: boolean) {
    /* when editorContent is empty
     *  populate the roles query.
     * */
    let table = this.security.tableName,
      userName = this.security.unamePropertyName,
      role = this.security.rolePropertyName;
    if (table && userName) {
      let rolesQuery = this.createRolesBySqlQuery(table, userName, role, this.security.queryType);
      if (saveEditorContent) {
        this.queryEditorContent = rolesQuery;
      }
      this.securityService.editorContent = rolesQuery;
    }
  }

  constructor(private queryBuilderService: QueryBuilderService, private httpService: WmHttpService) {
    super();
    this.securityService = inject(SecurityService);
  }

  makeFormDirty(value: any, $event?: any) {
    this.security[value] = $event;
  }

  override ngOnDestroy(): void {
    this.formChangesSubscription?.unsubscribe();
    this.resetFormSubscription?.unsubscribe();
  }
}
